import { render, staticRenderFns } from "./RadioButtonsField.vue?vue&type=template&id=72f5712e"
import script from "./RadioButtonsField.vue?vue&type=script&lang=js"
export * from "./RadioButtonsField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports